import styled from 'styled-components';
import { Form, Grid, Checkbox, Sidebar, Image, Message, Responsive } from 'semantic-ui-react';

export const WelcomeText = styled.p`
  font-size: 1.8em;
  padding-bottom: 0.1em;
  line-height: 1.3em;

  @media (max-width: 768px) {
    font-size: 1.5em;
  }

  @media (max-width: 480px) {
    font-size: 1.3em;
  }
`;

export const InfoText = styled.p`
  font-size: 1em;
  padding-bottom: 1em;

  @media (max-width: 768px) {
    font-size: 0.95em;
  }

  @media (max-width: 480px) {
    font-size: 0.9em;
  }
`;

export const Logo = styled(Image)`
  width: 6em;

  @media (max-width: 768px) {
    width: 5em;
  }

  @media (max-width: 480px) {
    width: 4em;
  }

  @media (max-width: 375px) {
    width: 3.5em;
  }
`;

export const Imag = styled(Image)`
  width: 8em;

  @media (max-width: 768px) {
    width: 6em;
  }

  @media (max-width: 480px) {
    width: 5em;
  }
`;

export const Confiax = styled.div`
  margin-top: 0.5em;
  text-align: center;
  display: flex;
  justify-content: center;

  @media (max-width: 480px) {
    margin-top: 0.3em;
  }
`;

export const Pushable = styled(Sidebar.Pushable)`
  height: 100vh !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-y: hidden !important;
  overflow-x: hidden !important;

  @media (max-width: 768px) {
    overflow-y: auto !important;
  }
`;

export const FormContainer = styled.div`
  margin-top: 4em;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 2.5em;
  }

  @media (max-width: 480px) {
    margin-top: 2em;
  }

  /* Garante touch targets adequados em mobile */
  button {
    min-height: 44px;
  }

  input {
    min-height: 44px;
    font-size: 16px !important; /* Previne zoom automático no iOS */
  }
`;

export const SideBarGrid = styled(Responsive)`
  height: 100%;
  flex: 0.25;
  display: flex;
  flex-direction: column;
  padding: 2em 4em;

  @media (max-width: 768px) {
    flex: 1;
    width: 100vw;
    padding: 2em 1.5em;
    justify-content: flex-start;
    padding-top: 3em;
  }

  @media (max-width: 480px) {
    padding: 1.5em 1em;
    padding-top: 2em;
  }

  @media (max-width: 375px) {
    padding: 1em 0.8em;
    padding-top: 1.5em;
  }
`;

export const Pusher = styled(Sidebar.Pusher)`
  flex: 0.75;

  @media (max-width: 1024px) and (min-width: 769px) {
    flex: 0.65; /* Ajusta para tablets em landscape */
  }

  @media (max-width: 768px) {
    display: none; /* Esconde a imagem no mobile */
  }
`;

export const ImageBackgroundCover = styled.div`
  position: absolute;
  height: 100vh;
  width: 100%;
  background-color: #0061ff;
  z-index: -1;
  opacity: 0.3;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageBackground = styled(Image)`
  width: 100%;
  position: absolute;
  top: -16em;
  z-index: -2;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ImageBackgroundText = styled.div`
  font-size: 2em;
  line-height: 1.5em;
  color: white;
  width: 100%;
  text-align: center;
  margin-top: 1em;

  @media (max-width: 1024px) {
    font-size: 1.7em;
  }

  @media (max-width: 768px) {
    font-size: 1.5em;
  }

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;
